module.exports = __webpack_public_path__ + "img/chef-bg-2.3a06f5d1.jpeg";